import { render, staticRenderFns } from "./illnessCreate.vue?vue&type=template&id=2b5d9ba2&"
import script from "./illnessCreate.vue?vue&type=script&lang=js&"
export * from "./illnessCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports